var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet-body form" }, [
    _c("form", { staticClass: "form-horizontal", attrs: { role: "form" } }, [
      _c("div", { staticClass: "form-body" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", { staticClass: "col-md-2 control-label" }, [
                  _vm._v(
                    _vm._s(_vm.trans("overproduction.select_type_of_date")) +
                      ":"
                  )
                ]),
                _vm._v(" "),
                _c("single-select", {
                  staticClass: "col-md-5",
                  attrs: {
                    name: "deliveryType",
                    options: _vm.deliveryTypes,
                    checked: _vm.selectedDeliveryType,
                    label: "value",
                    "allow-empty": false
                  },
                  on: {
                    dispatch: function($event) {
                      return _vm.$emit("disableSaveButtons", false)
                    },
                    change: _vm.changeDeliveryType
                  },
                  model: {
                    value: _vm.selectedDeliveryType,
                    callback: function($$v) {
                      _vm.selectedDeliveryType = $$v
                    },
                    expression: "selectedDeliveryType"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-5" },
                  [
                    _c("date-picker", {
                      attrs: { time: false, "is-nullable": false },
                      model: {
                        value: _vm.formDate,
                        callback: function($$v) {
                          _vm.formDate = $$v
                        },
                        expression: "formDate"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "col-md-2 control-label" }, [
                _vm._v("Marka sprzedażowa:")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c("multi-select", {
                    attrs: { options: _vm.sellBrands },
                    model: {
                      value: _vm.formSellBrands,
                      callback: function($$v) {
                        _vm.formSellBrands = $$v
                      },
                      expression: "formSellBrands"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "col-md-2 control-label" }, [
                _vm._v("Marka produkcyjna:")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c("multi-select", {
                    attrs: { options: _vm.productionBrands },
                    model: {
                      value: _vm.formProductionBrands,
                      callback: function($$v) {
                        _vm.formProductionBrands = $$v
                      },
                      expression: "formProductionBrands"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.search }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.trans("common.show")) +
                    "\n          "
                )
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01dfc426", { render: render, staticRenderFns: staticRenderFns })
  }
}